<template>
  <UCollapsible v-model:open="openCategories" class="lg:mx-3">
    <div
      class="flex w-full items-center justify-between rounded-md px-3 py-2 text-base font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-900"
    >
      <a :href="`/${category.externalId}`">
        {{ category.name }}
      </a>
      <div v-if="category.childrenCategories && category.childrenCategories.length" class="pl-6">
        <Icon
          name="heroicons:chevron-down-20-solid"
          :class="[open ? 'rotate-180' : '', 'h-5 w-5 flex-none']"
          aria-hidden="true"
        />
      </div>
    </div>
    <template #content>
      <div
        v-if="category.childrenCategories && category.childrenCategories.length"
        class="ml-4 mt-2 space-y-2"
      >
        <!-- Recursively render DjCategoryCollapsible for each child category -->
        <DjCategoryCollapsible
          v-for="child in category.childrenCategories"
          :key="child.id"
          :category="child"
        />
      </div>
    </template>
  </UCollapsible>
</template>

<script setup lang="ts">
  // Props passed to the component
  defineProps({
    category: {
      type: Object,
      required: true,
    },
  });
</script>

<style lang="scss" scoped>
  @use './DjCategoryCollapsible.scss';
</style>
